import React from 'react'
import { Menu, Icon, Label, Popup } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';


const Notifications = (props) => {

    let notify =
        <Popup
            className="cursor-pointer popupStyled"
            inverted
            position="top center"
            trigger={
                <Menu.Item
                    as='a'
                    name='notifications'
                    className="borderless clr-vr-lignt-blue" onClick={props.handleNotificationChange}
                    onMouseEnter={() => dispatch.app.setHelpContext("Notifications")}
                >
                    <Icon name='bell' size="large" style={{ margin: "0" }} />
                    {props.notificationsCount && props.notificationsCount.readCount && props.notificationsCount.readCount !== 0 ?
                        <Label className="notificationCountNumber bg-blue" circular  >
                            {props.notificationsCount.readCount ? props.notificationsCount.readCount : 0}
                        </Label>
                        : null}
                </Menu.Item>
            }
            content='Notifications'
        />

    let comments =
        <Menu.Item
            disabled
            as='a'
            name='comments'
            className="borderless clr-vr-lignt-blue"
            onClick={props.handleInboxVisibleChange}
            onMouseEnter={() => dispatch.app.setHelpContext("Message")}
        >
            <Icon name='comments' size="large" style={{ margin: "0" }} />
        </Menu.Item>

    //This is only display on local envoirnmant 
    let cache =
        <Menu.Item
            as='a'
            name='notifications'
            className="borderless clr-vr-lignt-blue"
            onClick={props.handleStorageVisibleChange}
        >
            <Icon name='dna' size="large" style={{ margin: "0" }} />
            {props.userCache > 0 ?
                <Label style={{ marginLeft: "1px" }} circular color='blue' >
                    {props.userCache ? props.userCache.length : 0}
                </Label>
                : ""}

        </Menu.Item>
    return (
        <Menu className="borderless header-notification-block" style={{ border: "0px", borderLeft: "1px solid #e5e5e5" }} >
            {comments}
            {notify}
            {window.location.hostname === "localhost" ? cache : null}
        </Menu>
    )
}

export default Notifications
